import accordionReducer, {
    AccordionActions,
} from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionReducer";
import formReducer, { FormActions } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormReducer";
import styleguideReducer, {
    StyleguideActions,
} from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    accordion: accordionReducer,
    form: formReducer,
    styleguide: styleguideReducer,
});

export type ComponentsActions = AccordionActions | FormActions | StyleguideActions;

export default componentsReducer;
